export default __webpack_public_path__ + "static/ico-iot-ccc2c14514de11c3bfda22d5777b11ea.svg";